var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"center"},[_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":96,"width":96},on:{"animCreated":_vm.handleAnimation}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }